export default function getPercentage(a: number, b: number): string {
  return `${Math.round((a * 100) / b).toLocaleString()}%`;
}
